import type { ReactNode } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Footer } from '@/shared/components/Footer';
import { usePolkadot } from '@/shared/hooks/usePolkadot';
import { Banners } from './Banners';
import { DepositAssetModal } from './Dashboard/DepositAssetModal/DepositAssetModal';
import Navbar from './Navbar';
import { PAGE_TITLES } from '../utils/seo';

export default function Layout({
  children,
  title: pageTitle,
  isMobileView = false,
  isMarketPage = false,
}: {
  children: ReactNode;
  title?: string;
  isMobileView?: boolean;
  isMarketPage?: boolean;
}) {
  const router = useRouter();
  const { selectedAccount } = usePolkadot();
  const fullTitle = PAGE_TITLES[router.pathname] ?? pageTitle;

  let content;

  if (isMarketPage) {
    content = children;
  } else {
    content = (
      <div className="flex w-screen justify-center">
        <div className="w-full px-8 py-6 2xl:container">{children}</div>
      </div>
    );
  }

  return (
    <>
      {fullTitle && (
        <Head>
          <title>{fullTitle}</title>
          <meta property="og:title" content={fullTitle} key="title" />
        </Head>
      )}

      <div
        className="grid min-h-screen w-full grid-rows-[auto_1fr] bg-cf-gray-2"
        style={{ marginTop: 'var(--banner-height)' }}
      >
        <div>
          <Banners isMobileView={isMobileView} />
          <Navbar logoHref="/portfolio" isMobileView={isMobileView} noContainer={isMarketPage} />
        </div>
        {content}
        <Footer app="lp" />
      </div>
      {selectedAccount && <DepositAssetModal />}
    </>
  );
}
